import { Component, Input, AfterViewInit } from '@angular/core';
import { PageConfiguration } from '../../../../models/page-configuration';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements AfterViewInit {
  @Input() pageConfig: PageConfiguration;

  constructor() { }

  ngAfterViewInit() {

    const accordions = document.querySelectorAll('.faq-accordion-title');

    for (let i = 0; i < accordions.length; i++) {
      accordions[i].addEventListener('click', _e => {
        this.toggleAccordion(_e.target);
      });

      accordions[i].addEventListener('keyup', _e => {
        if (_e['which'] === 13) {
          this.toggleAccordion(_e.target);
        }
      });
    }

  }

  closeOthers(elem: any) {

    const items = elem.querySelectorAll('.faq-accordion-item');
    for (let i = 0; i < items.length; i++) {
      items[i].querySelector('.faq-accordion-title').classList.remove('active');
      items[i].querySelector('.accordion-content').style.display = 'none';
    }
  }

  toggleAccordion(elem: any) {

    const accCtl = elem;
    const item = elem.closest('.faq-accordion-item');
    const wrapper = item.closest('.faq-accordion');
    const isActive = elem.classList.contains('active');

    if (isActive) {
      item.querySelector('.faq-accordion-title').classList.remove('active');
      item.querySelector('.accordion-content').style.display = 'none';
    } else {
      this.closeOthers(wrapper);
      item.querySelector('.faq-accordion-title').classList.add('active');
      item.querySelector('.accordion-content').style.display = 'block';
    }

  }
}
